import Header from './modules/header.js';
import Clouds from './modules/clouds.js';
import Bubbles from './modules/bubbles.js';
import SplideSlider from './modules/splideSlider.js';
import AnchorManager from './modules/anchor.js';
import Pagetop from './modules/pagetop.js';
import Movie from './modules/movie.js';


class App {
	constructor() {
		this.routes();
	}

	routes() {
		new Header();
		new Clouds();
		new Bubbles();
		new SplideSlider();
		new AnchorManager();
		new Pagetop();
		new Movie();
	}

}

window.App = new App();
